<section class="activities" [id]="activities.id">
  <div class="container">

    <div class="section-header">
      <span class="subtitle">
        {{ activities.subtitle }}
      </span>

      <h2>
        {{ activities.title }}
      </h2>

      <p>
        {{ activities.description }}
      </p>
    </div>

    <div class="activities-grid">

      @for (card of activities.cards; track card) {

        <div
          class="activity-card"
          [class.icon-only]="!card.imgUrl || brokenImageUrls().has(card.imgUrl)"
        >

          <div class="activity-media">

            @if (card.imgUrl && !brokenImageUrls().has(card.imgUrl)) {
              <div class="activity-image">
                <img
                  [src]="card.imgUrl"
                  [alt]="card.title"
                  (error)="onImageError(card.imgUrl)"
                />
              </div>
            }

            @else if (card.icon) {
              <div class="icon">
                <i [class]="card.icon"></i>
              </div>
            }

          </div>

          <div class="activity-card-details">

            <h3>
              {{ card.title }}
            </h3>

            <p>
              {{ card.description }}
            </p>

          </div>

        </div>

      }

    </div>

  </div>
</section>
